export enum ImageOutputType {
	JSON = 'b64_json',
	URL = 'url',
}
